module.exports = __webpack_public_path__ + "img/D-fb-icon.187ccde1.svg";